import { useSeo } from "../lib/seo";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { api, toEmbed } from "../lib/api";

const isInstagram = (u) => /instagram\.com/i.test(u || "");

export default function Social() {
  const [socials, setSocials] = useState([]);
  useSeo({
    title: "Media | Quantum Boas",
    description: "Videos, reels and behind-the-scenes from the Quantum Boas breeding program — feeding days, litter reveals and collection updates.",
  });

  useEffect(() => {
    api.get("/socials").then((r) => setSocials(r.data)).catch(() => {});
  }, []);

  return (
    <div className="grain pt-32 pb-24 px-6 md:px-10 min-h-screen">
      <div className="max-w-[1400px] mx-auto">
        <span className="text-xs tracking-[0.25em] uppercase text-qbprimary">Media</span>
        <h1 className="font-display text-5xl sm:text-6xl md:text-7xl mt-4 mb-3 leading-[1.02] pb-1">Highlights &amp; reels</h1>
        <p className="text-qbfg/55 max-w-xl mb-12">
          Feeding days, litter reveals and behind-the-scenes moments from the Quantum Boas program.
        </p>

        {socials.length === 0 ? (
          <p className="text-qbfg/40 py-20 text-center">No videos yet — check back soon.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="social-grid">
            {socials.map((s, i) => (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: (i % 2) * 0.08 }}
                data-testid={`social-${s.id}`}
                className={`rounded-xl overflow-hidden border bg-qbsurface ${s.pinned ? "border-qbprimary/50 ring-1 ring-qbprimary/40" : "border-white/10"}`}
              >
                <div className={`bg-black ${isInstagram(s.url) ? "aspect-[4/5]" : "aspect-video"}`}>
                  <iframe
                    src={toEmbed(s.url)}
                    title={s.title || "video"}
                    className="w-full h-full"
                    loading="lazy"
                    scrolling="no"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="p-5 flex items-center gap-3 flex-wrap">
                  {s.pinned && <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.2em] px-2.5 py-1 rounded-full bg-qbprimary/15 border border-qbprimary/40 text-qbprimary"><Star className="w-3 h-3" /> Featured</span>}
                  <span className="text-[10px] uppercase tracking-[0.2em] px-2.5 py-1 rounded-full border border-white/15 text-qbfg/60">{s.platform}</span>
                  <h3 className="font-display text-xl leading-[1.1] pb-0.5">{s.title}</h3>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
